// Domain
const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.genericComponents.iframe.';

const FETCHING_DESCRIPTION = `${DOMAIN}fetchingDescription`,
  FETCHING_TITLE = `${DOMAIN}fetchingTitle`,
  PROCESS_COMPLETED_DESCRIPTION = `${DOMAIN}processCompletedDescription`,
  PROCESS_COMPLETED_TITLE = `${DOMAIN}processCompletedTitle`;

export {
  FETCHING_DESCRIPTION,
  FETCHING_TITLE,
  PROCESS_COMPLETED_DESCRIPTION,
  PROCESS_COMPLETED_TITLE,
};
